export default __webpack_public_path__ + "static/media/money_bag.48674713.webp";